import { __assign, __spreadArray } from "tslib";
import combineQuery from 'graphql-combine-query';
import cloneDeep from 'lodash/cloneDeep';
var buildFragmentSpreadField = function (fragment, alias) {
    var fragmentName = fragment.name.value;
    return {
        arguments: [],
        directives: [],
        kind: 'Field',
        name: { kind: 'Name', value: fragmentName },
        selectionSet: {
            kind: 'SelectionSet',
            selections: [
                {
                    directives: [],
                    kind: 'FragmentSpread',
                    name: { kind: 'Name', value: alias || fragmentName },
                },
            ],
        },
    };
};
var buildFragmentDefinitionField = function (fragment, alias) {
    return __assign(__assign({}, fragment), { name: { kind: 'Name', value: alias } });
};
var addFragments = function (_a) {
    var rootQuery = _a.rootQuery, fragmentsMap = _a.fragmentsMap, pageFragments = _a.pageFragments, fragmentsAliases = _a.fragmentsAliases;
    var newQueryDocument = cloneDeep(rootQuery);
    var opDefinitionIndex = rootQuery.document.definitions.findIndex(function (item) { return item.kind === 'OperationDefinition'; });
    if (opDefinitionIndex !== -1) {
        var currentOpDefinition_1 = rootQuery.document.definitions[opDefinitionIndex];
        Object.keys(fragmentsMap).forEach(function (queryId) {
            var _a, _b;
            var selectionsIndex = (_a = currentOpDefinition_1.selectionSet) === null || _a === void 0 ? void 0 : _a.selections.findIndex(function (item) {
                var _a;
                return ((_a = item.alias) === null || _a === void 0 ? void 0 : _a.value) === queryId;
            });
            var currentSelections = (_b = currentOpDefinition_1.selectionSet) === null || _b === void 0 ? void 0 : _b.selections[selectionsIndex];
            if (currentSelections && fragmentsMap[queryId]) {
                var allFragmentsSpread = fragmentsMap[queryId]
                    .map(function (item) {
                    var _a, _b;
                    var alias = fragmentsAliases[item.fragmentId];
                    var hasFragment = (_b = (_a = currentSelections.selectionSet) === null || _a === void 0 ? void 0 : _a.selections) === null || _b === void 0 ? void 0 : _b.some(function (selection) { return selection.name.value === item.name.value; });
                    if (hasFragment)
                        return;
                    return buildFragmentSpreadField(item, alias);
                })
                    .filter(Boolean);
                var updatedWithSpread = __assign(__assign({}, currentSelections), { selectionSet: __assign(__assign({}, currentSelections.selectionSet), { selections: __spreadArray(__spreadArray([], currentSelections.selectionSet.selections, true), allFragmentsSpread, true) }) });
                newQueryDocument.document.definitions[opDefinitionIndex].selectionSet.selections[selectionsIndex] = updatedWithSpread;
            }
        });
    }
    return __assign(__assign({}, newQueryDocument), { document: __assign(__assign({}, newQueryDocument.document), { definitions: __spreadArray(__spreadArray([], newQueryDocument.document.definitions, true), pageFragments, true) }) });
};
export var parseSelectionsSet = function (selectionSet, oldVar, newVar) {
    var selections = parseSelections(selectionSet.selections, oldVar, newVar);
    selectionSet.selections = selections;
    return selections;
};
var parseSelections = function (selections, oldVar, newVar) {
    return selections.map(function (selection) {
        return parseSelection(selection, oldVar, newVar);
    });
};
var parseSelection = function (selection, oldVar, newVar) {
    var _a, _b;
    if (selection.selectionSet) {
        selection.selectionSet = __assign(__assign({}, selection.selectionSet), { selections: parseSelections(selection.selectionSet.selections, oldVar, newVar) });
    }
    if (!((_a = selection === null || selection === void 0 ? void 0 : selection.directives) === null || _a === void 0 ? void 0 : _a.length) || ((_b = selection === null || selection === void 0 ? void 0 : selection.directives) === null || _b === void 0 ? void 0 : _b.length) === 0) {
        return __assign({}, selection);
    }
    else {
        return __assign(__assign({}, selection), { directives: selection === null || selection === void 0 ? void 0 : selection.directives.map(function (d) {
                var _a;
                var parsedArguments = (_a = d === null || d === void 0 ? void 0 : d.arguments) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                    if (item.value.name.value == oldVar) {
                        return __assign(__assign({}, item), { value: __assign(__assign({}, item.value), { name: __assign(__assign({}, item.value.name), { value: newVar }) }) });
                    }
                    return item;
                });
                return __assign(__assign({}, d), { arguments: parsedArguments });
            }) });
    }
};
var queryBuilder = function (_a) {
    var queries = _a.queries, _b = _a.fragments, fragments = _b === void 0 ? {} : _b, dataSourceQueries = _a.dataSourceQueries;
    var fragmentsAliasesMap = {};
    var multipleQueries = dataSourceQueries.reduce(function (acc, _a) {
        var _b;
        var query = _a.query, id = _a.id, variables = _a.variables, fragments = _a.fragments;
        return (__assign(__assign({}, acc), (_b = {}, _b[query] = acc[query]
            ? __spreadArray(__spreadArray([], acc[query], true), [{ fragments: fragments, id: id, variables: variables }], false) : [{ fragments: fragments, id: id, variables: variables }], _b)));
    }, {});
    var fragmentsMap = dataSourceQueries.reduce(function (acc, _a) {
        var _b;
        var queryId = _a.id, queryFragments = _a.fragments;
        return __assign(__assign({}, acc), (_b = {}, _b[queryId] = queryFragments === null || queryFragments === void 0 ? void 0 : queryFragments.reduce(function (acc2, fragmentId) {
            var idValue = fragmentId;
            if (typeof fragmentId !== 'string') {
                idValue = fragmentId.name;
                if (fragmentId === null || fragmentId === void 0 ? void 0 : fragmentId.alias) {
                    fragmentsAliasesMap[idValue] = fragmentId === null || fragmentId === void 0 ? void 0 : fragmentId.alias;
                }
            }
            var aux = __assign(__assign({}, fragments[idValue].definitions[0]), { fragmentId: idValue });
            return __spreadArray(__spreadArray([], acc2, true), [aux], false);
        }, []), _b));
    }, {});
    var fragmentsDefinitions = Object.keys(fragments).reduce(function (acc, fragmentId) {
        var originalFragmentDefinitions = fragments[fragmentId].definitions[0];
        var fragmentAlias = fragmentsAliasesMap[fragmentId];
        var definition = fragmentAlias
            ? buildFragmentDefinitionField(originalFragmentDefinitions, fragmentAlias)
            : originalFragmentDefinitions;
        return __spreadArray(__spreadArray([], acc, true), [definition], false);
    }, []);
    var rootQuery = combineQuery('root');
    var combinedQueries = Object.keys(queries).reduce(function (combinedQuery, query) {
        var combinedVariables = multipleQueries[query].reduce(function (acc, item) { return __spreadArray(__spreadArray([], acc, true), [__assign({}, item.variables)], false); }, []);
        return combinedQuery.addN(queries[query], combinedVariables, function (varName, index) {
            var queryToParse = queries[query];
            var definitionsToParse = queryToParse.definitions.find(function (item) { return item.kind === 'OperationDefinition'; });
            var varParsed = "".concat(multipleQueries[query][index].id, "_").concat(varName);
            if (definitionsToParse.selectionSet) {
                // needed for handle nested variables to directives:
                // https://www.apollographql.com/docs/apollo-server/schema/directives/
                parseSelectionsSet(definitionsToParse.selectionSet, varName, varParsed);
            }
            return varParsed;
        }, function (_fieldName, index) {
            return "".concat(multipleQueries[query][index].id);
        });
    }, rootQuery);
    return fragmentsDefinitions.length
        ? addFragments({
            fragmentsAliases: fragmentsAliasesMap,
            fragmentsMap: fragmentsMap,
            pageFragments: fragmentsDefinitions,
            rootQuery: combinedQueries,
        })
        : combinedQueries;
};
export default queryBuilder;
//# sourceMappingURL=queryBuilder.js.map